<app-toolbar>  
  <app-tool-button text="Actualizar" i18n-text (click)="refresh();" color="has-color-blue" icon="fa-sync"></app-tool-button>
  <app-tool-button text="Filtre" i18n-text (click)="onFilterClicked();" color="has-color-orange" icon="fa-filter"></app-tool-button>
  <app-tool-button text="Excel" i18n-text (click)="generateExcel();" color="has-color-darkgreen" icon="fa-file-excel"></app-tool-button>
  <app-tool-button-permissions [permission]="this.authService.Pages.TramitadesGrua"></app-tool-button-permissions>
</app-toolbar>

<app-tramitades-table #tramitades [selectButton]="this.dataDialog.isDialog && !this.dataDialog.isReadOnly"  [updatedFilterData]="filter"></app-tramitades-table>